module.exports = __webpack_public_path__ + "img/Approve.cb72d8f4.svg";